/**
 * @hidden
 */
export var hasFilter = function (settings, column) { return settings.filter && column.field && column.filterable; };
/**
 * @hidden
 */
export var hasSort = function (settings, column) { return settings.sort && column.field && column.sortable; };
/**
 * @hidden
 */
export var hasLock = function (settings, column) {
    return settings.lock && column.lockable && !(column.parent && !column.parent.isSpanColumn);
};
/**
 * @hidden
 */
export var hasColumnChooser = function (settings) { return settings.columnChooser !== false; };
/**
 * @hidden
 */
export var hasItems = function (settings, column) {
    return hasColumnChooser(settings) || hasLock(settings, column) || hasSort(settings, column) || hasFilter(settings, column);
};



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-grid/dist/es/column-menu/utils.js
// module id = ../../../../@progress/kendo-angular-grid/dist/es/column-menu/utils.js
// module chunks = vendor